export default function (instance) {
  return {
    searchClients(query) {
      return instance.get(`/clients/get/search/?query=${query}`);
    },
    getClient(id) {
      return instance.get(`/clients/get/${id}`);
    },
    patchClient(payload) {
      return instance.put("/clients/patch", payload);
    },
    deleteClient(clientId) {
      return instance.delete(`/clients/delete/${clientId}`);
    },
    addNote(payload) {
      return instance.post("/notes/create", payload);
    },
    deleteNote(noteId) {
      return instance.delete(`/notes/delete/${noteId}`);
    },
    getByCardType(type) {
      return instance.get(`/clients/bycard?product_id=${Number(type)}`);
    },
    getBirthdays(params) {
      return instance.get("/v2/clients/birthdays", {params: params});
    },
    getInactiveClients(params) {
      return instance.get('/v2/clients/inactive', {params: params})
    }
  };
}
